import { render, staticRenderFns } from "./member.vue?vue&type=template&id=b19e3054&"
import script from "./member.vue?vue&type=script&lang=js&"
export * from "./member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports